module.exports = __webpack_public_path__ + "img/finalizado.3c4cc4d0.svg";